module.exports = __webpack_public_path__ + "img/a.bee8e6b7.jpg";